export default "__VITE_ASSET__DMz$ZSTk__"